export type GET = "GET";
export type HEAD = "HEAD";
export type POST = "POST";
export type PUT = "PUT";
export type DELETE = "DELETE";
export type CONNECT = "CONNECT";
export type OPTIONS = "OPTIONS";
export type TRACE = "TRACE";
export type PATCH = "PATCH";

export type HTTPMethodType = 
  GET | HEAD | POST | PUT | DELETE | CONNECT | OPTIONS | TRACE | PATCH;

export class HTTPMethodTypes
{
  static readonly GET:GET = "GET";
  static readonly HEAD:HEAD = "HEAD";
  static readonly POST:POST = "POST";
  static readonly PUT:PUT = "PUT";
  static readonly DELETE:DELETE = "DELETE";
  static readonly CONNECT:CONNECT = "CONNECT";
  static readonly OPTIONS:OPTIONS = "OPTIONS";
  static readonly TRACE:TRACE = "TRACE";
  static readonly PATCH:PATCH = "PATCH";

  static readonly all:HTTPMethodType[] = 
  [
    "GET",
    "HEAD",
    "POST",
    "PUT",
    "DELETE",
    "CONNECT",
    "OPTIONS",
    "TRACE",
    "PATCH",
  ];
}